<template>
  <div>
    <!-- 装扮购买弹窗 -->
    <van-dialog
      v-model="show"
      :lazy-render="true"
      :showConfirmButton="false"
      :close-on-click-overlay="true"
      :before-close="handleClose"
      @closed="activeIndexTime = 0"
    >
      <div class="dialog-part">
        <!-- 装扮信息 -->
        <div class="dialog-part-title">
          <div class="title-img">
            <img
              v-if="headUrl && partInfo.useType === 1"
              :src="headUrl"
              alt=""
            />
            <div class="part-pic-pendant">
              <Pendant :url="partInfo.motionUrl || partInfo.url" />
            </div>
          </div>
          <!-- <span>{{ partInfo.nameUig }}</span> -->
        </div>
        <!-- 价格 -->
        <div
          class="dialog-part-content"
          v-if="!('sku' in partInfo) || (partInfo.sku && partInfo.sku.length)"
        >
          <div class="part-price-diamond">
            <!-- <div class="part-price part-price-origin">
              <span>{{
                partInfo.sku && partInfo.sku[activeIndexTime].originalPrice
              }}</span>
              <img src="@/assets/part-diamond-origin.png" alt="" />
            </div> -->
            <span>{{
              language == 'ug' ? partInfo.nameUig : partInfo.name
            }}</span>
            <div class="part-price" v-html="resultPriceFixIcon(partInfo)"></div>
          </div>
          <!-- 时长 -->
          <div class="part-time">
            <p :class="['part-time-title', language]">
              {{ $t('选择购买时长') }}
            </p>
            <div class="part-time-list">
              <div
                :class="[
                  'part-time-item',
                  activeIndexTime === index && 'part-time-item-active'
                ]"
                v-for="(value, index) in 'sku' in partInfo
                  ? partInfo.sku
                  : [{ validDay: partInfo.exchangeDay }]"
                @click="activeIndexTime = index"
                :key="index"
              >
                {{
                  $t(`x天`, {
                    day: value.validDay
                  })
                }}
              </div>
            </div>
          </div>
          <!-- 购买 -->
          <div class="pay-box">
            <!-- <div class="pay-diamond" @click="hanleClick">
              <img src="@/assets/gameCoin/diamond.webp" alt="" />{{ 29999 }}
            </div>
            <div class="pay-gameCoin" @click="hanleClick">
              <img src="@/assets/gameCoin/game-coin-icon.png" alt="" />{{
                29999
              }}
            </div> -->
            <!-- <div class="pay-goldCoin" @click="hanleClick"><img src="@/assets/images/gold_coin_icon.webp" alt="" />{{ 29999 }}</div> -->
            <div class="pay-now" @click="hanleClick">{{ $t('购买') }}</div>
          </div>
        </div>
      </div>
    </van-dialog>

    <!-- 货币不足弹窗 -->
    <van-dialog
      v-model="notEnouhtShow"
      :showConfirmButton="false"
      :close-on-click-overlay="false"
    >
      <div class="not-enough">
        <div class="title">{{ $t('xx不足', { name: notEnougtObj.name }) }}</div>
        <p class="not-enough-content">
          {{
            $t(`xx不足，无法兑换商品。 购买xx后再来兑换吧~`, {
              name: notEnougtObj.name
            })
          }}
        </p>
        <div class="operation-btn">
          <div class="btn-cancel" @click="notEnouhtShow = false">
            {{ $t('好的，我知道了') }}
          </div>
          <div :class="['btn-confirm', language === 'ug' && 'btn-confirm-ug']" @click="handleConfim">
            {{ $t('购买xx', { name: notEnougtObj.name }) }}
          </div>
        </div>
      </div>
    </van-dialog>
    <!-- 使用弹窗 -->
    <ConfirmPopup
      :showPopup.sync="showPopup"
      @confirmExchange="confirmExchange"
      :popupObj="popupObj"
    />
  </div>
</template>

<script>
import Pendant from '@/components/Pendant.vue'
import { CommonModule } from '@/store/modules/common'
import {
  buyHeadPendant,
  exchangeRightsAndInterests,
  useRightsAndInterests
} from '@/api'
import { Toast } from 'vant'
import {
  appFunc_diamondsNotEnough,
  appFunc_LiveCoinsExchangeBuyGold,
  appFunc_LiveCoinsExchangeUse
} from '@/utils/bridge'
import { PageCommonModule } from '@/store/modules/page_common'
import ConfirmPopup from '@/views/game-coin/components/ConfimPopup.vue'

export default {
  name: 'ConvertPopup',
  components: {
    Pendant,
    ConfirmPopup
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    partInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    resultPriceFixIcon() {
      const icon_resource = {
        diamond: require('@/assets/gameCoin/diamond.webp'),
        gameCoin: require('@/assets/gameCoin/game-coin-icon.png'),
        goldCoin: require('@/assets/images/gold_coin_icon.webp')
      }
      return value => {
        let img_resource = icon_resource.diamond
        let currencyCode = null
        let price = ''
        // 装扮
        if ('sku' in value) {
          if (!(value.payType == 2 && value.sku[0]))
            return `<span>${this.$t('非卖品')}</span>`
          currencyCode = value.sku[0].currencyCode
          price = value.sku[this.activeIndexTime].currentPrice
        } else {
          // 权益
          currencyCode = value.currencyCode
          price = value.gameCoin
        }
        if (currencyCode == 1) img_resource = icon_resource.diamond
        else if (currencyCode == 3) img_resource = icon_resource.gameCoin
        else if (currencyCode == 4) img_resource = icon_resource.goldCoin
        return img_resource
          ? `<span style="padding: 0 2px;font-size: 18px;">${price}</span><img style="width: 20px; height: 20px; margin-left: 2px" src="${img_resource}" alt="" />`
          : ''
      }
    },
    headUrl() {
      return PageCommonModule.userInfo?.headUrl
    }
  },
  data() {
    return {
      popupObj: {},
      showPopup: false,
      knapsackId: undefined,
      notEnouhtShow: false,
      notEnougtObj: {
        type: 1,
        name: this.$t('金币')
      },
      show: false,
      activeIndexTime: 0,
      language: CommonModule.language
    }
  },
  watch: {
    isShow(newVal) {
      this.show = newVal
    }
  },
  methods: {
    // 刷新用户信息
    refreshUserInfo() {
      console.log('刷新用户信息')

      PageCommonModule.getUserInfo()
      PageCommonModule.getShopDataList()
    },
    handleClose() {
      this.$emit('update:isShow', false)
    },
    // 购买装扮
    hanleClick() {
      // 判断权益或者装扮
      if ('sku' in this.partInfo) {
        if (!(this.partInfo.sku && this.partInfo.sku.length)) return
        const { pendantId, validDay } = this.partInfo.sku[this.activeIndexTime]
        const params = {
          pendantId,
          validDay
        }
        buyHeadPendant(params).then(res => {
          if (res.code == 1001) {
            Toast(this.$t('兑换成功'))
            this.refreshUserInfo()
          } else {
            this.handleExchangeFail(res.code, res.message)
          }
          this.show = false
          this.$emit('update:isShow', false)
        })
      } else {
        // 权益购买逻辑
        exchangeRightsAndInterests(this.partInfo?.id).then(res => {
          if (res.code === 1001) {
            this.knapsackId = res.data
            this.partInfo?.id !== 9 ? this.handleUsePopup() : Toast(this.$t('兑换成功'))
            this.refreshUserInfo()
          } else {
            this.handleExchangeFail(res.code, res.message)
          }
          this.show = false
          this.$emit('update:isShow', false)
        })
      }
    },
    // 处理兑换失败
    handleExchangeFail(code, message) {
      // [钻石,金币,游戏币]
      ;[10301, 13011, 11025].includes(code)
        ? (this.notEnouhtShow = true)
        : Toast(message)
      this.notEnougtObj = {
        type: code === 10301 ? 1 : code === 13011 ? 4 : 3,
        name:
          code === 10301
            ? this.$t('钻石')
            : code === 13011
            ? this.$t('金币')
            : this.$t('游戏币')
      }
    },
    // 权益使用弹窗
    handleUsePopup() {
      this.showPopup = true
      this.popupObj = {
        popupTitle: this.$t('提示'),
        sureText: this.$t('是否立即使用“xxx”?', {
          name: `<span style="color: #FA5051; font-weight: bold;" class="${
            this.language
          }">${
            this.language === 'ug'
              ? this.partInfo?.nameUig
              : this.partInfo?.name
          }</span>`
        }),
        cancleText: this.$t('暂时不用'),
        confirmText: this.$t('立即使用'),
        isUse: true, // 使用弹窗
        isusePop: this.partInfo?.type === 1 && this.partInfo?.id !== 9 // 1、装扮 2、权益
      }
      setTimeout(() => {
        Toast(this.$t('兑换成功'))
      }, 100)
    },
    // 购买货币
    handleConfim() {
      this.notEnouhtShow = false
      setTimeout(() => {
        if (this.notEnougtObj.type === 1) {
          // 钻石
          appFunc_diamondsNotEnough()
        } else if (this.notEnougtObj.type === 3) {
          // 游戏币
          this.$router.push({
            path: '/gameCoin',
            query: {
              language: this.language,
              statusBarHeight: +this.$route.query.statusBarHeight,
              isH5: true
            }
          })
        } else if (this.notEnougtObj.type === 4) {
          // 金币
          appFunc_LiveCoinsExchangeBuyGold()
        }
      }, 300)
    },
    // 使用弹窗
    confirmExchange() {
      useRightsAndInterests(this.knapsackId).then(res => {
        if (res.code === 1001) {
          this.showPopup = false
          Toast(this.$t('使用成功'))
          appFunc_LiveCoinsExchangeUse(2) // 装扮使用成功后回调原生
        } else {
          Toast(res.message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-part {
  width: 322px;
  // height: 344px;
  background: #1a0d43;

  .dialog-part-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    background: url('../../../assets/part-dialog-title-bg.png') no-repeat;
    background-size: cover;
    background-position: center center;
    padding: 30px 0 15px 0;

    .title-img {
      width: 100%;
      height: 80px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
      }
    }

    .part-pic-pendant {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
    }

    span {
      padding-top: 15px;
    }
  }

  .dialog-part-content {
    padding: 10px 28px 20px;

    .part-price-diamond {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;

      .part-price {
        display: flex;
        align-items: center;

        img {
          width: 20px;
          height: 20px;
        }
      }

      .part-price-origin {
        position: relative;
        font-size: 16px;
        color: #999999;

        &::after {
          content: ' ';
          position: absolute;
          top: 50%;
          left: -2px;
          width: 105%;
          height: 1.8px;
          background: #999999;
        }
      }

      span {
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
      }
    }

    .part-time {
      .part-time-title {
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        padding: 20px 0 10px 0;
      }

      .part-time-list {
        display: flex;
        justify-content: space-between;

        .part-time-item {
          width: 83px;
          height: 46px;
          line-height: 46px;
          text-align: center;
          background: rgba(0, 0, 0, 0.2);
          border-radius: 8px 8px 8px 8px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
        }

        .part-time-item-active {
          background: rgba(185,117,255,0.2);
          border: 1px solid #955EFF;
        }
      }
    }

    .pay-now {
      flex: 1;
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: #955EFF;
      border-radius: 23px;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
    }
  }
}
::v-deep .van-dialog {
  top: 50%;
}
.pay-box {
  display: flex;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  padding-top: 22px;
  img {
    width: 28px;
    height: 28px;
    margin-right: 4px;
  }
  .pay-diamond,
  .pay-gameCoin,
  .pay-goldCoin {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    border-radius: 23px;
    margin-right: 8px;
  }
  .pay-diamond {
    background: linear-gradient(270deg, #5e6eff 0%, #75aeff 100%);
  }
  .pay-gameCoin {
    background: #955EFF;
  }
  .pay-goldCoin {
    background: #955EFF;
  }

  &:last-child {
    margin-right: 0 !important;
  }
}
.not-enough {
  padding: 20px 12px;
  box-sizing: border-box;
  border: 20px;
  .title {
    font-weight: 500;
    font-size: 18px;
    color: rgba(0, 0, 0, 0.8);
    text-align: center;
  }
  .not-enough-content {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    padding: 20px 55px 22px;
    text-align: center;
    line-height: 18px;
  }
  .operation-btn {
    display: flex;
    div {
      flex: 1;
      line-height: 44px;
      text-align: center;
      border-radius: 23px;
      font-weight: 400;
      font-size: 16px;
    }
    .btn-cancel {
      background: #f3f4f6;
      color: #999999;
      margin-right: 8px;
    }
    .btn-confirm {
      background: #955EFF;
      color: #ffffff;
    }
    .btn-confirm-ug {
      font-family: 'UKIJCJK';
      font-size: 12px;
    }
  }
}
</style>
